import { type ItemParameterChangeDataWrapper } from "@/types";

export enum Event {
  CollectionParamsChanged,
  CollectionParamsSynchronize,

  OpenAuthDialog,

  OpenCookieConsent,

  MarketplaceItemRenewed,
}

export type EmitConfig =
  // Events with NO additional data expected
  | {
      event: Event.CollectionParamsSynchronize | Event.OpenAuthDialog | Event.OpenCookieConsent;
    }
  | {
      event: Event.MarketplaceItemRenewed;
      data: { allRenewed: boolean };
    }
  // Events WITH some additional data expected
  | {
      event: Event.CollectionParamsChanged;
      data: ItemParameterChangeDataWrapper;
    };

export const EventBus = {
  listeners: new Map<Event, CallableFunction[]>(),

  on: function (event: Event, fn: CallableFunction) {
    if (!this.listeners.get(event)) {
      this.listeners.set(event, []);
    }

    this.listeners.get(event)?.push(fn);
  },

  off: function (event: Event, fn?: CallableFunction) {
    const thisEventlisteners = this.listeners.get(event);
    if (thisEventlisteners !== undefined) {
      if (fn) {
        for (let i = 0; i < thisEventlisteners.length; i++) {
          if (thisEventlisteners[i] === fn) {
            thisEventlisteners.splice(i, 1);
            break;
          }
        }
      } else {
        this.listeners.set(event, []); // off all
      }
    }
  },

  emit: function (emitConfig: EmitConfig) {
    const listeners = this.listeners.get(emitConfig.event);
    if (listeners) {
      listeners.forEach(function (fn: CallableFunction) {
        if ("data" in emitConfig) {
          fn(emitConfig.data);
        } else {
          fn();
        }
      });
    }
  },
};
